import { IControlProvider } from '@ibiz-template/runtime';
/**
 * 树适配器
 *
 * @author lxm
 * @date 2022-10-25 18:10:57
 * @export
 * @class TreeProvider
 * @implements {IControlProvider}
 */
export class TreeProvider implements IControlProvider {
  component: string = 'IBizTreeControl';
}
